module.exports = __webpack_public_path__ + "img/eyes_male_extra_thin_mask.d0eaf6fb.png";